var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('AppChart',{ref:"chart",staticStyle:{"cursor":"pointer"},attrs:{"max-height":"500px","max-width":"500px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }